import React from 'react'

import type { IStop } from '../../../../../types/shipment'
import { Stop } from './stop'

/**
 * This component is used to render the stops list in the stops section
 */
export const StopsList = ({ stops }: { stops: IStop[] }) => {
  return (
    <div className="space-y-5">
      {stops.map((stop) => (
        <Stop key={stop.id} stop={stop} />
      ))}
    </div>
  )
}
